import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, LoadingController, ModalController, NavParams } from '@ionic/angular';
import { Ogp6Service } from 'src/app/services/ogp6.service';

@Component({
  selector: 'app-visualizar-ogp6',
  templateUrl: './visualizar-ogp6.page.html',
  styleUrls: ['./visualizar-ogp6.page.scss'],
})
export class VisualizarOgp6Page implements OnInit {

  public formulario: any = {};
  public usuario: any = {};
  public id;
  constructor(
    public router: Router,
    private activateRoute: ActivatedRoute,
    private ogp6Service: Ogp6Service,
    private modalController: ModalController,
    private navParams: NavParams,
    private loadingController: LoadingController,
    private alertController: AlertController
  ) {
    this.usuario = JSON.parse(localStorage.getItem('usuario'));
    this.id = this.navParams.get('id');
  }

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.ogp6Service.getReporteById(this.id)
      .then((reporte: any) => {
        this.formulario.id_ogp_6 = reporte.id_ogp_6;
        this.formulario.nombreServidor = reporte.nombre + ' ' + reporte.modelo;
        this.formulario.fechaFalla = reporte.fecha_hora;
        this.formulario.tipoElemento = reporte.tipo_elemento;
        this.formulario.tiempoIndisponibilidad = reporte.tiempo_indisponibilidad;
        this.formulario.tiempoParametros = reporte.tiempo_parametros;
        this.formulario.tiempoRetraso = reporte.tiempo_retraso_datos;
        this.formulario.tiempoDesconexion = reporte.tiempo_desconexion;
        this.formulario.tiempoCorreccion = reporte.tiempo_correccion;
        this.formulario.compartida = reporte.compartida;
      })
  }

  redireccionXRol() {
    let url = ''
    switch (this.usuario.id_tipo_usuario) {
      case 3: url = '/menuAutocontrol/gestion-obac6'; break;
    }
    return url;
  }

  async cerrar() {
    await this.modalController.dismiss();
  }

  async actualizar() {
    const loading = await this.loadingController.create({
      message: 'Guardando información...',
      spinner: 'lines'
    });
    await loading.present();

    this.ogp6Service.actualizar(this.formulario.id_ogp_6, this.formulario)
      .then(data => {
        loading.dismiss();
        this.mensajes('OGP 6', '', 'La información se ha guardado con éxito')
      })
      .catch(err => {
        loading.dismiss();
        this.mensajes('OGP 6', '', 'Algo salió mal vuelve a intentarlo más tarde')
      })
  }

  async mensajes(header, subHeader, message) {
    const alert = await this.alertController.create({
      header: header,
      subHeader: subHeader,
      message: message,
      buttons: ['Aceptar']
    });

    await alert.present();
  }

  async compartir() {
    const alert = await this.alertController.create({
      header: '¿Estás seguro de compartir la información?',
      message: 'La información se compartirá con el AAS',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
          }
        }, {
          text: 'Compartir',
          handler: async () => {
            const loading = await this.loadingController.create({
              message: 'Comparitendo información...',
              spinner: 'lines'
            });
            await loading.present();

            this.ogp6Service.compartir(this.formulario.id_ogp_6)
            .then((data:any)=>{
              loading.dismiss();
              this.mensajes('OGP-6R1', 'Código '+ data.code, data.msg)
              this.formulario.compartida=1;
            })
            .catch(err=>{
              this.mensajes('Algo salió mal', 'Vuelve intentarlo nuevamente','Si el error persiste comunícate con soporte, code: OGP6R1-'+ this.id)
              loading.dismiss();
            })
          }
        }
      ]
    });
    await alert.present();
  }

}
